import * as React from 'react';

import { PerformanceOverviewNumbers } from '@components/performanceOverviewNumbers';
import { performanceOverviewNumbersMobileClassName } from './lib/PerformanceOverviewNumbersMobileStyles';
import type { PerformanceOverviewNumbersPropsType } from '@components/performanceOverviewNumbers/types';

const NumbersMobile: React.FC<PerformanceOverviewNumbersPropsType> = (props) => {
    return (
        <div className={performanceOverviewNumbersMobileClassName}>
            <PerformanceOverviewNumbers {...props} />
        </div>
    );
};

export { NumbersMobile };
